export const slideInTop = `
  animation-duration: .5s;
  animation-name: slideinTop;

  @keyframes slideinTop {
      0% {
        opacity: 0;
        transform: translateY(100%);
      }

      100% {
          opacity: 1;
          transform: translateY(0%);
      }
  }
`;

export const slideOutTop = `
  animation-duration: .5s;
  animation-name: slideOutTop;
  opacity: 0;
  transform: translateY(100%);

  @keyframes slideOutTop {
      0% {
        opacity: 1;
        transform: translateY(0%);
      }

      100% {
          opacity: 0;
          transform: translateY(100%);
      }
  }
`;

export const slideInBottom = `
  animation-duration: .5s;
  animation-name: slideInBottom;

  @keyframes slideInBottom {
      0% {
        opacity: 0;
        transform: translateY(-100%);
      }

      100% {
          opacity: 1;
          transform: translateY(0%);
      }
  }
`;

export const slideOutBottom = `
  animation-duration: .5s;
  opacity: 0;
  transform: translateY(-100%);
  animation-name: slideOutBottom;

  @keyframes slideOutBottom {
      0% {
        opacity: 1;
        transform: translateY(0%);
      }

      100% {
        opacity: 0;
        transform: translateY(-100%);
      }
  }
`;
